/**
 * isDuplicate — checks if a title is a near-duplicate of any existing title.
 * Used by DayView (filter) and ActivityEditPanel (log-only).
 */
export function isDuplicate(newTitle, existingTitles) {
  const norm = s => s.toLowerCase().replace(/[^a-z0-9]/g, '');
  const newNorm = norm(newTitle);
  if (!newNorm) return false;
  return existingTitles.some(t => {
    const existNorm = norm(t);
    if (!existNorm) return false;
    return newNorm.includes(existNorm) ||
           existNorm.includes(newNorm) ||
           newNorm === existNorm;
  });
}
